export function parseUrl (url) {
    return new URL(url)
}
